module.exports = __webpack_public_path__ + "media/bootstrap-icons/record-circle-fill-ba06e96b.svg";